import ProgramParticipantList from "./ProgramParticipantList";
import useProgram from "../../hooks/useProgram";
import { useProgram as useProgramState } from "../../ProgramContext";

export function ProgramParticipantListContainer() {
  // @todo: make this component conditional on the program phase
  return null;

  const { program } = useProgram();

  const { user } = useProgramState();

  return (
    <ProgramParticipantList
      userParticipants={program?.user_participation}
      userImage={user?.photo}
    />
  );
}

export default ProgramParticipantListContainer;
